export default {"src":"https://fishbrain.com/_next/static/media/waning_crescent.70705a91.svg","height":32,"width":33,"blurWidth":0,"blurHeight":0};